import React from 'react';
import { Plus, X, Layers } from 'lucide-react';

const S = {
  label: {
    fontSize: '0.7rem', fontWeight: 700, color: '#c5a059', textTransform: 'uppercase',
    letterSpacing: '0.06em', marginBottom: '4px', display: 'block',
  },
  input: {
    width: '100%', background: 'rgba(7, 21, 38, 0.8)', border: '1px solid rgba(197,160,89,0.25)',
    borderRadius: '8px', padding: '8px 12px', fontSize: '0.8rem', color: '#e2e8f0',
    outline: 'none', boxSizing: 'border-box', fontFamily: "'Inter', sans-serif",
  },
  btnSecondary: {
    background: 'rgba(197,160,89,0.1)', color: '#c5a059', border: '1px solid rgba(197,160,89,0.3)',
    borderRadius: '10px', padding: '8px 14px', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: '7px', whiteSpace: 'nowrap',
  },
  btnDanger: {
    background: 'rgba(239,68,68,0.1)', color: '#f87171', border: '1px solid rgba(239,68,68,0.3)',
    borderRadius: '10px', padding: '6px 10px', fontSize: '0.72rem', fontWeight: 700, cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap',
  },
};

// Editor de flashcards de una lección: array de { front, back } (o { t, b }).
export const FlashcardsEditor = ({ flashcards = [], onChange }) => {
  const list = Array.isArray(flashcards) ? flashcards : [];
  const set = (next) => onChange(next);
  const update = (i, patch) => set(list.map((f, x) => (x === i ? { ...f, ...patch } : f)));

  return (
    <div>
      <label  style={{  ...S.label }} className="adm-label">
        <Layers size={12} style={{ verticalAlign: '-2px', marginRight: '6px' }} />
        Flashcards de la Lección (frente / reverso)
      </label>
      <p style={{ margin: '0 0 10px', fontSize: '0.68rem', color: '#64748b', lineHeight: 1.5 }}>
        Tarjetas propias de esta lección. Si se dejan vacías, el alumno verá las que se
        generan automáticamente a partir del quiz y los puntos clave.
      </p>
      {list.map((f, i) => (
        <div key={f.id || i} style={{
          border: '1px solid rgba(197,160,89,0.25)', borderRadius: '10px', padding: '10px',
          marginBottom: '8px', display: 'flex', flexDirection: 'column', gap: '8px',
        }}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <input
              type="text"
              value={f.front || f.t || ''}
              onChange={(e) => update(i, { front: e.target.value })}
              style={{ ...S.input, flex: 1 }}
              placeholder="Frente: pregunta / concepto"
            />
            <button
              type="button"
              onClick={() => set(list.filter((_, x) => x !== i))}
              style={{ ...S.btnDanger, padding: '6px 10px' }}
            >
              <X size={12} />
            </button>
          </div>
          <textarea
            rows={2}
            value={f.back || f.b || ''}
            onChange={(e) => update(i, { back: e.target.value })}
            style={{ ...S.input, resize: 'vertical' }}
            placeholder="Reverso: respuesta / definición"
          />
        </div>
      ))}
      <button
        type="button"
        onClick={() => set([...list, { front: '', back: '' }])}
        style={{ ...S.btnSecondary, borderColor: 'rgba(197,160,89,0.4)', color: '#c5a059' }}
      >
        <Plus size={12} /> <span>Agregar flashcard</span>
      </button>
    </div>
  );
};
